import { JSX, StrictMode } from "react"
import { HashRouter, Route, Routes } from "react-router"

import { BodyClassNameProvider } from "./Context/BodyClassNameContext"
import MainMenuPage from "./Page"
import { DailyGame, GamePage } from "./Page/GamePage"
import DemoPage from "./Page/DemoPage"

import config from "./config.json"

export default function App(): JSX.Element {
  return (
    <StrictMode>
      <BodyClassNameProvider>
        <HashRouter>
          <Routes>
            <Route path="/" Component={MainMenuPage} />
            <Route path="/play/:seed" Component={GamePage} />
            <Route path="/daily" Component={DailyGame} />
            {config.debug && <Route path="/demo" Component={DemoPage} />}
          </Routes>
        </HashRouter>
      </BodyClassNameProvider>
    </StrictMode>
  )
}
